import React, {
    ReactNode,
    createContext,
    useContext,
    useState,
  } from "react";
  
  
  interface UrlAuthContextProps {
    urlAuth: string;
    setUrlAuth: Function ;
  }
  
  interface UrlAuthProviderProps {
    children: ReactNode;
  }
  
  const UrlAuthContext = createContext<UrlAuthContextProps | undefined>(undefined);

  
  const UrlAuthProvider: React.FC<UrlAuthProviderProps> = ({ children }) => {
    const [urlAuth, setUrlAuth] = useState('');
  
    return (
      <UrlAuthContext.Provider value={{ setUrlAuth ,urlAuth }}>{children}</UrlAuthContext.Provider>
    );
  };
  
  export const useUrlAuthContext = () => {
    const context = useContext(UrlAuthContext);
    if (!context) {
      throw new Error("useUrlAuthContext must be used within a UrlAuthProvider");
    }
    return context;
  };
  
  export default UrlAuthProvider;
  